const getUserCurrentProgress = (number, days) => {
  if (!number || !days) {
    return 0;
  }
  return Math.trunc(((number === 1 ? 0 : number - 1) / days.length) * 100);
};

export default getUserCurrentProgress;
